import { type MCPServerInfo } from '../../types';

const SailpointServer: MCPServerInfo = {
  serverId: 'SAILPOINT',
  name: 'Sailpoint',
  slug: 'sailpoint',
  description: 'Sailpoint MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: './sailpoint-mcp',
    commitSha: '20250624-104703',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['identitynowApiKey', 'port'],
    properties: {
      identitynowApiKey: {
        type: 'string',
        description: 'Identitynow APIKey',
        sensitive: true
      },
      port: {
        type: 'string',
        description: 'Port',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default SailpointServer;
